import * as Actions from '../constant/ActionTypes';

const listNewFeaturesReducer = (listAllFeatures = [], action) => {
    switch(action.type) {
        case Actions.LIST_NEW_FEATURES:
            return action.payload;

        default:
            return listAllFeatures;
    }
}
export default listNewFeaturesReducer;